import appIcon from "@/assets/app-icon.png";

/** Shown when VITE_SUPABASE_* are not set — avoids a blank page from createClient() throwing at import time. */
export default function MissingSupabaseEnv() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="max-w-md w-full rounded-2xl border border-border bg-card p-8 shadow-lg space-y-4 text-center">
        <img src={appIcon} alt="" className="w-12 h-12 rounded-xl mx-auto" />
        <h1 className="font-display font-bold text-lg text-foreground">
          Configure Supabase for local dev
        </h1>
        <p className="text-sm text-muted-foreground leading-relaxed">
          Copy <code className="text-xs bg-muted px-1.5 py-0.5 rounded">.env.example</code> to{" "}
          <code className="text-xs bg-muted px-1.5 py-0.5 rounded">.env</code> and set:
        </p>
        <ul className="text-left text-sm text-muted-foreground space-y-2 font-mono text-xs bg-muted/50 rounded-lg p-4">
          <li>VITE_SUPABASE_URL</li>
          <li>VITE_SUPABASE_PUBLISHABLE_KEY</li>
        </ul>
        <p className="text-xs text-muted-foreground">
          Values are in Supabase Dashboard → Project Settings → API. Restart{" "}
          <code className="bg-muted px-1 rounded">npm run dev</code> after saving.
        </p>
      </div>
    </div>
  );
}
